import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterListingPage_template} from "./filterListingPage_template";

declare var ko: any;

export class multipleHubPagesWidget_template extends vnTemplate {

    public listingPageFilter: filterListingPage_template;

    protected getTemplateName(): string {
        return "multipleHubPagesWidget_template";
    }
    protected initPartial(): void {
        this.listingPageFilter = new filterListingPage_template("multipleHubPagesWidget", this.getTemplateViewModel(), this.caller);
        this.listingPageFilter.setPlaceholder('Multiple Hub Pages');
        this.listingPageFilter.setShowDetails(true);
        this.listingPageFilter.setIsLoadingAnimationEnable(true);
    }

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="multiple-hub-pages">

                <div class="form-group" data-bind="visible: errorMessage() != ''" style="background-color: #e8c9c9; padding: 1rem; margin: 1rem 2rem; border-radius: 5px;">
                    <span class="form-error" style="color: #8f0101;  text-align: left;" data-bind="text: errorMessage"></span>
                </div>
                
               <!-- ko if: showIncludeDbSearch() == true -->
               <div class="form-group" >
                  <input type="checkbox" id="includeDbSearch-title" data-bind="checked: includeDbSearch" id="includeDbSearch-title">
                  <label for="includeDbSearch-title" class="icon i-check">Include DB Search</label>
               </div>
               <!-- /ko -->
               <div class="form-group">
                  <label class="form-label">Hub Page Selection</label>
                  ${this.listingPageFilter.getHtmlBuild()}
               </div>
               <div class="form-group">
                   <label class="form-label" for="alternateTitle">Alternate Title</label>
                   <div class="last">                                        
                       <input type="text" class="input-text" id="alternateTitle" data-bind="value: alternateTitle, attr: {placeholder: alternateTitlePlaceholder}">
                   </div>
               </div>
               <button class="btn secondary" type="button" data-bind="enable: buttonEnable, event:{click: onClickAdd }, text: 'Add to Position ' + (listingPages().length + 1)"></button>
               
               <div class="form-group">
                   <label class="form-label">Layout</label>
                   <div class="featured-pinned-list">
                       <div class="featured-pinned-element">
                           <input type="radio" name="layoutFull" id="_layoutMediumGrid" data-bind="checked: layoutFullWidth, checkedValue: 'mediumGrid', click: onValidate()">
                           <label class="form-label icon featured-medium-grid" for="_layoutMediumGrid"></label>
                           <label class="form-label" for="_layoutMediumrid">Medium Grid</label>
                       </div>
                       <div class="featured-pinned-element">
                           <input type="radio" name="layoutFull" id="_layoutLargeGrid" data-bind="checked: layoutFullWidth, checkedValue: 'largeGrid', click: onValidate()">
                           <label class="form-label icon featured-large-grid" for="_layoutLargeGrid"></label>
                           <label class="form-label" for="_layoutLargeGrid">Large Grid</label>
                       </div> 
                   </div>
               </div>
               
               <div class="listing-pages" data-bind="if: listingPages().length > 0">
                   <table class="listing-page">
                       <thead>
                            <tr>
                                <th>Position</th>
                                <th>Name</th>
                                <th>Alternate Title</th>
                            </tr>
                       </thead>
                       <tbody data-bind="foreach: listingPages">
                            <tr>
                                <td data-bind="text: $index() + 1"></td>
                                <td data-bind="text: name"></td>
                                <td data-bind="text: alternateTitle"></td>
                                <td>
                                    <button class="btn-form icon i-delete" type="button" data-bind="event:{ click: $parent.onClickRemove}"></button>
                                </td>
                            </tr>
                        </tbody>
                   </table>
               </div> 
            </div>
        `;
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            listingPages: ko.observableArray([]),
            maximum: ko.observable(20),
            errorMessage: ko.observable(''),
            alternateTitle: ko.observable(''),
            alternateTitlePlaceholder: ko.observable(''),
            buttonEnable: ko.observable(true),
            layoutFullWidth: ko.observable('mediumGrid'),
            showIncludeDbSearch: ko.observable(false),
            includeDbSearch: ko.observable(false),
            onClickAdd: () => {
                self.onClickAdd();
            },
            onClickRemove: (data,event) =>{
                self.onClickRemove(data)
            },
            onValidate: () => {
                self.onValidate();
            },
            onClickIncludeDbSearch: () => {
                self.onClickIncludeDbSearch();
            }
        };
    }

    public reset() {
        this.getTemplateViewModel().listingPages([]);
        this.getTemplateViewModel().alternateTitle('');
        this.getTemplateViewModel().buttonEnable(true);
        this.getTemplateViewModel().includeDbSearch(false);
        this.listingPageFilter.getTemplateViewModel().listingPageObj(null);
        this.listingPageFilter.toggleCloseButton();
    }

    public setAlternateTitlePlaceholder(placeholder: string): void {

        this.getTemplateViewModel().alternateTitlePlaceholder(placeholder);
    }

    public getAlternateTitlePlaceholder() {
        return this.getTemplateViewModel().alternateTitlePlaceholder();
    }

    public setOptions(options) {
        this.listingPageFilter.setOptions(options);
    }

    public getListingPages() {
        return this.getTemplateViewModel().listingPages();
    }

    public setListingPages(listingPages) {
        this.getTemplateViewModel().listingPages(listingPages);
    }

    public getMaximum() {
        return this.getTemplateViewModel().maximum();
    }

    public setMaximum(maximum) {
        this.getTemplateViewModel().maximum(maximum);
    }

    public getAlternateTitle() {
        return this.getTemplateViewModel().alternateTitle();
    }

    public setAlternateTitle(alternateTitle) {
        this.getTemplateViewModel().alternateTitle(alternateTitle);
    }

    public detectIfDBSearchIsEnabled() {

        let idBrand = this.caller.getBrandId();

        this.setShowIncludeDbSearch([6, 20, 44].indexOf(idBrand) > -1);
    }

    public setShowIncludeDbSearch(showIncludeDbSearch) {
        this.getTemplateViewModel().showIncludeDbSearch(showIncludeDbSearch);
    }

    public getShowIncludeDbSearch() {
        return this.getTemplateViewModel().showIncludeDbSearch();
    }

    public getIncludeDbSearch() {
        return this.getTemplateViewModel().includeDbSearch();
    }

    public setIncludeDbSearch(includeDbSearch) {
        this.getTemplateViewModel().includeDbSearch(includeDbSearch);
    }

    protected onClickAdd() {

        this.getTemplateViewModel().errorMessage('');

        const selected = this.listingPageFilter.getTemplateViewModel().listingPageObj();

        if (selected == null){
            this.getTemplateViewModel().errorMessage('Please select a listing page.');
            return;
        }

        const listingPages = this.getListingPages();
        const inList = listingPages.filter((item) => item.id === selected.id);
        if(inList.length > 0){

            this.getTemplateViewModel().errorMessage('Listing page already added.');
            return;
        }

        this.getTemplateViewModel().errorMessage('');

        listingPages.push({
            id: selected.id,
            name: selected.name,
            permalink: selected.permalink,
            alternateTitle: this.getAlternateTitle()
        });

        this.setListingPages([]);
        this.setListingPages(listingPages);
        this.setAlternateTitle('');
        this.listingPageFilter.removeListingFromSelection(selected.id);
        this.listingPageFilter.toggleCloseButton();
        this.onValidate();
    }

    protected onClickRemove(data) {

        let listingPages = this.getListingPages();
        listingPages = listingPages.filter((item) => item.id !== data.id);
        this.setListingPages([]);
        this.setListingPages(listingPages);
        this.onValidate();
    }

    protected onValidate() {
        this.caller.validateMultipleHubPages();
    }

    protected onClickIncludeDbSearch() {

    }

    public getLayoutFullWidth() {
        return this.getTemplateViewModel().layoutFullWidth();
    }

    public setLayoutFullWidth(layoutFullWidth) {
        this.getTemplateViewModel().layoutFullWidth(layoutFullWidth);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/multipleHubPagesWidget_template.ts